module.exports = __webpack_public_path__ + "static/media/view.0ff237cc.svg";